import { t } from '@lingui/macro';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { onChangeMapFilters } from '../../../ac/onChangeMapFilters';
import { LegendRenderer } from '../../LegendRenderer';
import { AGG_USER_OPENS_TO_STARTS_LEGEND } from '../../../constants/legends';
import * as V from '../../../constants/variables';
import { StandardRadioGroup } from '../StandardRadioGroup';
import styles from '../FilterSidebar.module.css';

const OpensToStartFilterComponent = ({ OpensToStartDays, onChangeMapFilters }) => {
    const filterValue = OpensToStartDays;
    const onChange = ({ target: { value } }) => {
        const key = 'OpensToStartDays';
        onChangeMapFilters(key, +value);
    };

    return (
        <div>
            <div className={styles.legHead}>{t`Открытий к стартам`}:</div>
            <StandardRadioGroup
                value={String(filterValue)}
                onChange={onChange}
            >
                {
                    V.userTapsFilterValues.map(value => (
                        <FormControlLabel
                            key={value}
                            className={styles.isochroneFilterLabel}
                            control={
                                <Radio
                                    checked={filterValue === value}
                                    onChange={onChange}
                                    value={value}
                                    className={classnames(
                                        styles.isochroneFilterInput, {
                                            [styles.checkedIsochroneFilterInput]: filterValue === value,
                                        }
                                    )}
                                    size='small'
                                />
                            }
                            label={t`${value} дней`}
                            labelPlacement='end'
                        />
                    ))
                }
            </StandardRadioGroup>
            <LegendRenderer config={AGG_USER_OPENS_TO_STARTS_LEGEND} />
            <div style={{ padding: '10px' }}>
                <span className={styles.legendSubtitle}>{t`Учитываются гексагонами с 3+ стартами`}</span>
            </div>
        </div>
    );
};
const mapStateToProps = ({ mapFilters: { OpensToStartDays } }) => ({
    OpensToStartDays,
});
const ConnectedComponent = connect(mapStateToProps, { onChangeMapFilters })(OpensToStartFilterComponent);

export const OpenToStartsFilter = withDisplayedLayersCheck(ConnectedComponent, 'Открытий к стартам');
